module.exports = __webpack_public_path__ + "img/20.1581ce8f.jpg";